import { FC } from 'react'
import styled from 'styled-components'

interface IContainerProps {
  aspectRatioPct?: number
  height?: number
  maxWidth?: number
  tabletHeight?: number
  width?: string
}

const Container = styled.div<IContainerProps>`
  align-items: center;
  background-color: ${props => props.theme.colors.transparentRedAlpha10};
  display: flex;
  justify-content: center;

  ${props => props.height && `height: ${props.height}px;`}
  ${props => props.maxWidth && `max-width: ${props.maxWidth};`}
  ${props => props.width && `width: ${props.width};`}
  ${props =>
    props.aspectRatioPct
    && `
    /* keeps aspect ratio fixed as container width changes */
    ::before {
      content: "";
      display: inline-block;
      height: 0;
      padding-bottom: ${props.aspectRatioPct}%;
    }
  `}
  ${props =>
    props.tabletHeight
    && `
    @media(min-width: ${props.theme.metrics.tablet}px) {
      height: ${props.tabletHeight}px;
    }
  `}
`

const Text = styled.span`
  color: ${props => props.theme.colors.red};
  padding: 12px 16px 10px; /* 2 px more top padding for vertical centering fix */
`

interface IProps extends IContainerProps {
  errorMessage: string
}

/**
 * The purpose of this component is only to show an error message.  All other props should be
 * style-related.  The reason this component exists is the styling in ErrorBox became overly complex
 * for this use-case.
 */
const ErrorMessageBox: FC<IProps> = ({ errorMessage, ...containerProps }) => (
  <Container {...containerProps}>
    <Text>{errorMessage}</Text>
  </Container>
)

export default ErrorMessageBox
